import { useState } from 'react'
import { CollapsibleCardProps } from './types'
import styles from './CollapsibleCard.module.scss'
import classNames from 'classnames'
import { Card, Icon } from '@boltenergy-be/design-system'

const CollapsibleCard = ({
  disabled,
  onOpen,
  startCollapsed,
  titleSection,
  children,
  contentClassName,
  ...cardProps
}: CollapsibleCardProps) => {
  // Local state
  const [isOpen, setIsOpen] = useState<boolean>(!startCollapsed)

  return (
    <Card className={classNames(styles.collapsible, { [styles.disabled]: disabled })} {...cardProps}>
      <header
        className={classNames(styles['title-section'], { [styles.open]: isOpen })}
        onClick={() => {
          if (!disabled) {
            setIsOpen(!isOpen)
            onOpen?.()
          }
        }}
        role="presentation"
      >
        {titleSection}
        <span className={styles['collapse-icon']}>
          <Icon name={isOpen ? 'chevronUp' : 'chevronDown'} size={20} />
        </span>
      </header>

      {isOpen && <div className={contentClassName}>{children}</div>}
    </Card>
  )
}

export default CollapsibleCard
